import { cn } from "@/lib/cn";

/**
 * Contenedor de ancho de página homologado (doc UX 20260627: "ampliar el ancho
 * máximo de los formularios; aprovechar el espacio horizontal en Full HD;
 * unificar márgenes y espaciados").
 *
 * `width`:
 *  - form   formularios de una columna (lectura cómoda).
 *  - wide   listados/tablas/detalles a dos columnas.
 *  - full   aprovecha el ancho de contenido completo.
 */
export function PageContainer({
  width = "wide",
  className,
  children,
}: {
  width?: "form" | "wide" | "full";
  className?: string;
  children: React.ReactNode;
}) {
  const max = width === "form" ? "max-w-3xl" : width === "wide" ? "max-w-5xl" : "max-w-content";
  return <div className={cn("mx-auto w-full space-y-5", max, className)}>{children}</div>;
}
